import { useFilterInfractionContext } from "./filter-infraction.context";

export function FilterInfraction() {
  const { dateFilterElement, clearFiltersElement } =
    useFilterInfractionContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {clearFiltersElement}
    </div>
  );
}